import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

/**
 * Previsualización del creativo de un anuncio Meta. `fetchPreview(creativeId)`
 * llama en vivo al endpoint scopeado a la marca (usa el token de la marca, no
 * el del usuario) y no persiste nada; se renderiza el `preview_html` (embed de
 * Meta). Se abre desde el botón "Ver" de un anuncio.
 */
export default function AdPreviewModal({ ad, fetchPreview, onClose }) {
  const [html, setHtml] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | ready | error

  useEffect(() => {
    let alive = true;
    setStatus('loading');
    Promise.resolve(fetchPreview(ad.creative_id))
      .then((d) => {
        if (!alive) return;
        const preview =
          d && typeof d === 'object' && 'preview_html' in d ? d.preview_html : typeof d === 'string' ? d : null;
        setHtml(preview);
        setStatus(preview ? 'ready' : 'error');
      })
      .catch(() => alive && setStatus('error'));
    return () => {
      alive = false;
    };
  }, [ad.creative_id, fetchPreview]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div className="w-full max-w-sm rounded-xl bg-white shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3">
          <div className="min-w-0">
            <p className="truncate text-sm font-medium text-gray-900">{ad.ad_name || 'Anuncio'}</p>
            {ad.adset_name && <p className="truncate text-xs text-gray-500">{ad.adset_name}</p>}
          </div>
          <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-700" aria-label="Cerrar">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex min-h-[420px] items-center justify-center p-4">
          {status === 'loading' && <p className="text-sm text-gray-500">Cargando previsualización…</p>}
          {status === 'error' && (
            <p className="px-4 text-center text-sm text-gray-500">
              No se pudo cargar la previsualización de este anuncio.
            </p>
          )}
          {status === 'ready' && (
            <div
              className="w-full overflow-hidden [&_iframe]:mx-auto [&_iframe]:max-w-full"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
